import React, { useState, useEffect } from "react";
import Slider from "./people";
import { MyCustomContextHook } from "../Navigation_Bar/Context";
import { RiArrowDropLeftLine } from "react-icons/ri";
import { RiArrowDropRightLine } from "react-icons/ri";

const SliderData = () => {
  const { submenuClosed, closeExtraSubmenu } = MyCustomContextHook();
  const [data, setData] = useState(Slider);
  const [countIndex, setCountIndex] = useState(0);

  const nextSlideBtn = () => {
    setCountIndex((oldIndex) => {
      let countIndex = oldIndex + 1;
      if (countIndex > data.length - 1) {
        countIndex = 0;
      }
      return countIndex;
    });
  };

  const prevSlideBtn = () => {
    setCountIndex((oldIndex) => {
      let countIndex = oldIndex - 1;
      if (countIndex < 0) {
        countIndex = data.length - 1;
      }
      return countIndex;
    });
  };

  useEffect(() => {
    let autoSlide = setInterval(() => {
      setCountIndex((oldIndex) => {
        let countIndex = oldIndex + 1;
        if (countIndex > data.length - 1) {
          countIndex = 0;
        }
        return countIndex;
      });
    }, 5000);
    return () => {
      clearInterval(autoSlide);
    };
  }, [countIndex]);

  const removeSubmenuThroughBody = (e) => {
    if (!e.target.classList.contains("list-items")) {
      submenuClosed();
      closeExtraSubmenu();
    }
  };

  return (
    <>
      <section
        className="slider-section"
        onMouseOver={removeSubmenuThroughBody}
      >
        <div className="slider-section-center">
          {data.map((item, itemIndex) => {
            const { id, img, largeText, miniText, button } = item;

            let position = "next-slide";
            if (itemIndex === countIndex) {
              position = "active-slide";
            }
            if (
              itemIndex === data - 1 ||
              (countIndex === 0 && itemIndex === data.length - 1)
            ) {
              position = "last-slide";
            }

            return (
              <article className={position} key={id}>
                <img src={img} alt={largeText} className="slider-img" />
                <div
                  className={`${largeText && miniText ? "text-body" : null}`}
                >
                  <h3>{largeText}</h3>
                  <p className="text">{miniText}</p>
                  <div className="container-slider-btn">
                    {button ? (
                      <button className="slider-btn">{button}</button>
                    ) : null}
                  </div>
                </div>
              </article>
            );
          })}

          <button className="prev" onClick={prevSlideBtn}>
            <RiArrowDropLeftLine />
          </button>
          <button className="next" onClick={nextSlideBtn}>
            <RiArrowDropRightLine />
          </button>
        </div>
      </section>
    </>
  );
};

export default SliderData;
